"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const IntegrationSharedSettings_1 = require("../IntegrationSharedSettings");
const ApiCredentialsCard_1 = require("../ApiCredentialsCard");
exports.SailthruSettings = ({ integration }) => {
    return (react_1.default.createElement(reusables_1.Form, { mutationProps: {
            mutation: graphql_1.updateSailthru,
            refetchQueries: [
                {
                    query: graphql_1.integration,
                    variables: {
                        id: integration.id,
                    },
                },
            ],
        }, valuesToVariables: values => {
            return {
                data: {
                    apiPublicKey: values.apiPublicKey.trim(),
                    apiSecretKey: values.apiSecretKey.trim(),
                    name: values.name.trim(),
                },
                id: integration.id,
            };
        }, formikProps: {
            initialValues: {
                apiPublicKey: integration.apiPublicKey,
                apiSecretKey: integration.apiSecretKey,
                name: integration.name,
            },
            validationSchema: () => Yup.object().shape({
                apiPublicKey: Yup.string().trim(),
                apiSecretKey: Yup.string().trim(),
                name: Yup.string()
                    .trim()
                    .required('Required'),
            }),
        }, showBottomToolbar: true }, formikProps => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IntegrationSharedSettings_1.IntegrationSharedSettings, { integration: integration, formikProps: formikProps, sidebar: react_1.default.createElement(ApiCredentialsCard_1.ApiCredentialsCard, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "API public key", name: "apiPublicKey", autoComplete: "off" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "API key", name: "apiSecretKey", type: "password", autoComplete: "off" }),
                react_1.default.createElement("p", { className: "mb-0" },
                    react_1.default.createElement("a", { href: "https://getstarted.sailthru.com/developers/api-basics/technical/", target: "_blank", rel: "noopener noreferrer" }, "Find your API key on Sailthru"))) })))));
};
//# sourceMappingURL=SailthruSettings.js.map